import { I18nKey } from 'i18n/types';

export enum SortByAccommodations {
  PRICE = 'price',
  NAME = 'name',
  RATING = 'rating',
}

export const SortByAccommodationsMap: Record<SortByAccommodations, I18nKey['common']> = {
  [SortByAccommodations.NAME]: 'resort.lodging.name',
  [SortByAccommodations.PRICE]: 'resort.lodging.price',
  [SortByAccommodations.RATING]: 'resort.lodging.starRating',
};

export const SortByAccommodationsOptions = [SortByAccommodations.RATING, SortByAccommodations.NAME, SortByAccommodations.PRICE].map(
  (e) => ({
    value: e,
    label: SortByAccommodationsMap[e],
  }),
);

export const SortByAccommodationsDefault = SortByAccommodations.RATING;

export const sortByAccommodationsDefault = {
  value: SortByAccommodationsDefault,
  label: SortByAccommodationsMap[SortByAccommodationsDefault],
};
